import React from 'react';

const ShimmerCard = () => {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden w-full h-full flex flex-col">
      {/* Image Skeleton */}
      <div className="w-full bg-gray-200 animate-pulse" style={{ height: '220px' }}></div>
      
      {/* Content Skeleton */}
      <div className="p-5 flex flex-col gap-4 flex-grow">
        {/* Title */}
        <div className="h-6 bg-gray-200 rounded animate-pulse w-3/4"></div>
        
        {/* Location / Meta */}
        <div className="h-4 bg-gray-200 rounded animate-pulse w-1/2"></div>
        
        {/* Features / Details */}
        <div className="flex gap-2 mt-2">
          <div className="h-6 w-16 bg-gray-200 rounded-full animate-pulse"></div>
          <div className="h-6 w-16 bg-gray-200 rounded-full animate-pulse"></div>
          <div className="h-6 w-16 bg-gray-200 rounded-full animate-pulse"></div>
        </div>
        
        <div className="mt-auto pt-4 border-t border-gray-100 flex justify-between items-center">
          {/* Price */}
          <div className="h-6 bg-gray-200 rounded animate-pulse w-1/3"></div>
          {/* Button */}
          <div className="h-8 w-24 bg-gray-200 rounded-lg animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default ShimmerCard;
